module.exports = __webpack_public_path__ + "img/CastleAdrinhurst4.4998d7a9.png";